<template>
  <div
    class="menu-option"
    :class="{
      'menu-option--selected': active,
      'menu-option--heading': isHeading,
      'menu-option--avatar': avatar,
      'menu-option--compact': compact,
    }"
    @click="emit('select', item)"
  >
    <span v-if="country" class="menu-option__flag">
      <UICountryIcon :key="item.iso2" :iso2="item.iso2"></UICountryIcon>
    </span>
    <span v-else-if="multiple && !isHeading" class="menu-option__checkbox">
      <UICheckbox
        :id="id"
        sync-v-model
        :model-value="active"
        :controlled="false"
        :name="id"
        @click.prevent
      ></UICheckbox>
    </span>
    <UIAvatar
      v-if="avatar && !isHeading"
      :user="item"
      width="20"
      height="20"
      no-border
      :src="item.image"
      :alt="itemName"
    />
    <div class="menu-option__default">
      <slot>
        <span class="menu-option__name">{{ itemName }}</span>
      </slot>
      <UIIcon v-if="active && !country && !multiple" class="menu-option__icon--active" name="check" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { HEADING_VALUE } from '../../../constants'

export type MenuOptionProps = {
  item: any
  active: boolean
  country?: boolean
  multiple?: boolean
  avatar?: boolean
  compact?: boolean
  labelKey?: string
}

defineSlots<{
  default: () => any
}>()

const props = defineProps<MenuOptionProps>()

const instance = getCurrentInstance()
const uid = ref(instance?.uid)

const itemName = computed(() => {
  if (props.labelKey) {
    return props.item[props.labelKey]
  }

  const name = props.item.name || props.item.text

  if (props.country) {
    return `${name} ${props.item.phone_code}`
  }

  return name
})

const id = computed(() => {
  return `${uid.value}-${String(props.item?.id) || ''}`
})

const isHeading = computed(() => {
  return props.item.value === HEADING_VALUE
})

const emit = defineEmits<{
  (e: 'select', option: any): void
}>()
</script>

<style scoped lang="scss">
@use '../../../styles/mixins.scss' as *;

@include menuOption();
</style>
